var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation-container"},[(_vm.activeName != 'line' && _vm.activeName != 'video')?_c('sprite-animation'):_vm._e(),(_vm.activeName == 'line')?_c('line-animation'):_vm._e(),(_vm.activeName == 'video')?_c('video-animation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }